import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import MissingNetworkAccessFeeAlert from "../components/MissingNetworkAccessFeeAlert";
import { useAuth } from "./AuthContext";
import { BASE_URL } from "../config";

const MissingNetworkAccessFeeAlertContext = createContext();

export const MissingNetworkAccessFeeAlertProvider = ({ children }) => {
  const [showAlert, setShowAlert] = useState(false);
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) return;

    const checkMissingNetworkAccessFee = async () => {
      try {
        // const response = await axios.get("/api/v1/corporate/missing-network-access-fee", {
        const response = await axios.get(`${BASE_URL}/missing-network-access-fee`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        if (response.data.data.corporates.length > 0) {
          setShowAlert(true);
        }
      } catch (err) {
        console.error("Error checking missing network_access_fee:", err);
      }
    };

    checkMissingNetworkAccessFee();
  }, [isAuthenticated]);

  return (
    <MissingNetworkAccessFeeAlertContext.Provider value={{ showAlert, setShowAlert }}>
      {showAlert && <MissingNetworkAccessFeeAlert onClose={() => setShowAlert(false)} />}
      {children}
    </MissingNetworkAccessFeeAlertContext.Provider>
  );
};

export const useMissingNetworkAccessFeeAlert = () => useContext(MissingNetworkAccessFeeAlertContext);